// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"161":"a4cd8664","192":"7ca1bedb","408":"b79056d5","482":"7afcb063","819":"bcbd6a5d"}[chunkId] + ".js";
};